import { Table, TableBody, TableHead, TableRow } from "@mui/material";

import MDTypography from "@/components/atoms/MDTypography";
import {
  HeaderTableCell,
  TableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { formatCurrency } from "@/helpers/currency-helpers";
import { FinancialTransaction } from "@/interfaces/talk2pay.iterfaces";
import { T2PayHomeMessages } from "@/messages/platforms/talk2PayHome/t2pay-home.messages";

import { StatementTableRow } from "./row";
import { STATEMENT_TABLE_COLUMNS } from "../../../constants";

interface StatementTableProps {
  messages: T2PayHomeMessages;
  financialTransaction: FinancialTransaction | null;
}

export function StatementTable({ messages, financialTransaction }: StatementTableProps) {
  const finalBalance = 33213.12;
  return (
    <TableContainer>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableHeaderRow>
            {STATEMENT_TABLE_COLUMNS(messages).map((label, index) => (
              <HeaderTableCell
                key={`${index} - ${label}`}
                align={
                  label === messages.valueColumn || label === messages.balanceColumn
                    ? "right"
                    : "left"
                }
              >
                {label}
              </HeaderTableCell>
            ))}
          </TableHeaderRow>
        </TableHead>
        <TableBody>
          {financialTransaction &&
            financialTransaction.transactions.map((transaction, index) => {
              return (
                <StatementTableRow index={index} key={transaction.id} transation={transaction} />
              );
            })}
          {financialTransaction && (
            <TableRow>
              <TableCell colSpan={4}>
                <MDTypography variant="button" fontWeight={"bold"}>
                  {messages.balanceFooter}
                </MDTypography>
              </TableCell>
              <TableCell align="right">
                <MDTypography color={finalBalance >= 0 ? "info" : "error"} variant="button">
                  {formatCurrency(financialTransaction.finalBalance)}
                </MDTypography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
